export const legacyCardSuffix = "-tarot-card-reading-meaning";

export function slugifyCardName(value) {
  return String(value || "")
    .toLowerCase()
    .trim()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function cleanCardSlug(cardOrSlug) {
  if (!cardOrSlug) return "";
  if (typeof cardOrSlug === "string") {
    return cardOrSlug.replace(new RegExp(`${legacyCardSuffix}$`), "");
  }
  return cardOrSlug.cleanSlug || slugifyCardName(cardOrSlug.name || cardOrSlug.title || cardOrSlug.slug);
}

export function cardPath(cardOrSlug, cardsBySlug) {
  if (!cardOrSlug) return "/tarot-cards";
  if (typeof cardOrSlug === "string" && cardOrSlug.startsWith("/")) return cardOrSlug;

  if (typeof cardOrSlug === "string" && cardsBySlug) {
    const resolved = resolveCardBySlug(cardsBySlug, cardOrSlug);
    return `/tarot-card/${cleanCardSlug(resolved || cardOrSlug)}`;
  }

  return `/tarot-card/${cleanCardSlug(cardOrSlug)}`;
}

export function legacyCardPath(card) {
  const slug = typeof card === "string" ? card : card?.slug;
  return slug ? `/tarot-card/${slug}` : "/tarot-cards";
}

export function resolveCardBySlug(cardsBySlug, slug) {
  if (!slug || !cardsBySlug) return null;
  const normalizedSlug = String(slug).replace(/^\/?tarot-card\//, "");
  if (cardsBySlug[normalizedSlug]) return cardsBySlug[normalizedSlug];

  const cards = Array.isArray(cardsBySlug) ? cardsBySlug : Object.values(cardsBySlug);
  return (
    cards.find((card) => cleanCardSlug(card) === normalizedSlug) ||
    cards.find((card) => card?.slug === normalizedSlug) ||
    null
  );
}

export function isLegacyCardSlug(card, slug) {
  if (!card || !slug) return false;
  return card.slug === slug && cleanCardSlug(card) !== slug;
}
